import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=2971df40&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Collection-pc.css?vue&type=style&index=0&id=2971df40&scoped=true&lang=css&"
import style1 from "../assets/css/Collection-phone.css?vue&type=style&index=1&id=2971df40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971df40",
  null
  
)

export default component.exports